import React, { useEffect, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Flex, Text } from '@radix-ui/themes'
import { useResponsive } from 'shared/hooks/use-responsive'
import { globalOverlayLoadingVar } from 'shared/store/global-overlay-state-store'
import { XyroLoadingSpinner } from '../xyro-loading-spinner'
import styles from './global-loader-overlay.module.scss'

const OVERLAY_FAILSAFE_MS = 12_000

export const GlobalLoaderOverlay: React.FC = () => {
  const [isOverlayOpened, setOverlayOpened] = useState(true)

  const isGlobalOverlayStateLoading = useReactiveVar(globalOverlayLoadingVar)

  useEffect(() => {
    if (isGlobalOverlayStateLoading) return

    setOverlayOpened(false)
  }, [isGlobalOverlayStateLoading])

  useEffect(() => {
    if (!isOverlayOpened) return

    const timeout = setTimeout(() => {
      setOverlayOpened(false)
      globalOverlayLoadingVar(false)
    }, OVERLAY_FAILSAFE_MS)

    return () => clearTimeout(timeout)
  }, [isOverlayOpened])

  const [isMobile] = useResponsive('sm')

  if (isMobile || !isOverlayOpened) return null

  return (
    <div className={styles.overlay}>
      <Flex
        className={styles.loaderContainer}
        align={'center'}
        justify={'center'}
        direction={'column'}
      >
        <XyroLoadingSpinner iconSize='8' />

        <Text
          mt={'3'}
          size={'4'}
          weight={'bold'}
        >
          LOADING...
        </Text>
      </Flex>
    </div>
  )
}
